/**
 * 筛选器默认值配置组件
 * 根据筛选器类型分发到不同的子组件：
 * - 日期类型：FilterDateDefaultValue
 * - 字符串类型：FilterStringDefaultValue
 * - 数值类型（字符串字段上的数值）：FilterNumberDefaultValue
 */

import React, { useMemo } from 'react';
import type { IFilterState } from '../../types';
import FilterDateDefaultValue from './FilterDateDefaultValue';
import FilterStringDefaultValue from './FilterStringDefaultValue';
import FilterNumberDefaultValue from './FilterNumberDefaultValue';

interface IFilterDefaultValueProps {
  state: IFilterState;
  dispatch: React.Dispatch<any>;
  gameCode: string;
  isDisabledCompare: boolean;
  isEn: boolean;
  filterColumnRef: React.RefObject<{ getDateColumns: () => any[]; }>;
}

const FilterDefaultValue: React.FC<IFilterDefaultValueProps> = (props) => {
  const { state } = props;

  // 判断是否为数值筛选器（字段类型为数值类型）
  // 规则：
  // - 运行时 filterType 已经是 'number' 的场景（来自旧数据或保存后的再次编辑）
  // - 或 UI 仍使用 'string'，但字段标记为 isNumeric 的场景（新建时自动识别数值字段）
  const isNumberFilter = useMemo(() => {
    if (state.filterType === 'number') {
      return true;
    }
    return state.filterType === 'string' && state.columnInfo?.isNumeric === true;
  }, [state.filterType, state.columnInfo?.isNumeric]);

  if (state.filterType === 'date') {
    return <FilterDateDefaultValue {...props} />;
  }

  if (isNumberFilter) {
    return <FilterNumberDefaultValue {...props} />;
  }

  if (state.filterType === 'string') {
    return <FilterStringDefaultValue {...props} />;
  }

  return null;
};

export default FilterDefaultValue;

